import { INVITE_RELATIONS_MAP, INVITE_SOURCE_MAP } from '../constants'

/**
 * 根据用户Map，获取非默认邀请的用户ID
 */
export const filterNotDefaultInviteUserIds = (usersObj) => {
  return Object.keys(usersObj).filter(userId => {
    return usersObj[userId].inviteSourceCode !==  INVITE_SOURCE_MAP.DEFAULT_INVITATION.code
  })
}


/**
 * 根据关系代码获取关系内容
 */
export const getRelationsByCode = (code) => {
  switch(parseInt(code)) {
    case INVITE_RELATIONS_MAP.SAME_LEADER.code: {
      return INVITE_RELATIONS_MAP.SAME_LEADER.label
    }
    case INVITE_RELATIONS_MAP.NO_SAME_LEADER.code: {
      return INVITE_RELATIONS_MAP.NO_SAME_LEADER.label
    }
    case INVITE_RELATIONS_MAP.DIRECTLY_SUBORDINATE.code: {
      return INVITE_RELATIONS_MAP.DIRECTLY_SUBORDINATE.label
    }
    case INVITE_RELATIONS_MAP.DIRECTLY_LEADER.code: {
      return INVITE_RELATIONS_MAP.DIRECTLY_LEADER.label
    }
  }
}